export const splitOnce = (s: string, splitOn: string | RegExp, joinOn: string) => {
  const [first, ...rest] = s.split(splitOn)
  return [first, rest.length > 0? rest.join(joinOn) : null];
}
